import React, { useRef } from 'react';
import firstWorldCapitalize from '../../utils/capitlizedFirstLatter';
import ParseFloat from '../../utils/ParseFloat';

const DownloadReceipt = ({ t, data, orderId }: any) => {
    const iframeRef = useRef<HTMLIFrameElement>(null);

    const handleReceiptDownload = () => {
        const htmlContent = `
        <html>
          <head>
            <title>Receipt - ${orderId}</title>
            <style>
              body {
                font-family: Arial, sans-serif;
                background-color: #fff;
                padding: 40px;
              }
              .receipt-container {
                background-color: #fff;
                padding: 24px;
                width: 100%;
                max-width: 400px;
                margin: auto;
                border-radius: 10px;
                box-shadow: 0 2px 10px rgba(0,0,0,0.1);
              }
              .title {
                font-size: 20px;
                font-weight: 600;
                text-align: center;
                margin-bottom: 20px;
              }
              .row {
                display: flex;
                justify-content: space-between;
                font-size: 14px;
                margin-bottom: 8px;
              }
              .total {
                margin-top: 12px;
                padding-top: 10px;
                border-top: 1px solid #ddd;
                font-weight: bold;
                font-size: 16px;
              }
              @media print {
                body {
                  -webkit-print-color-adjust: exact;
                }
              }
            </style>
          </head>
          <body>
            <div class="receipt-container">
              <div class="title">${t("OrderSuccess.order")}</div>
              <div class="row"><span>${t("OrderSuccess.order")}</span><span>${orderId}</span></div>
              <div class="row"><span>${t("OrderSuccess.payment")}</span><span>${firstWorldCapitalize(data?.payment_option)}</span></div>
              ${data?.sub_total ? `<div class="row"><span>${t("CartDetails.subTotals")}</span><span>${ParseFloat(data?.sub_total)}</span></div>` : ''}
              ${data?.discountAmount ? `<div class="row"><span>${t("MyOrders.discount")}</span><span>${ParseFloat(data?.discountAmount)}</span></div>` : ''}
              ${data?.service_charge ? `<div class="row"><span>${t("Checkout.serviceFee")}</span><span>${ParseFloat(data?.service_charge)}</span></div>` : ''}
              ${data?.delivery_charges ? `<div class="row"><span>${t("Checkout.deliveryFee")}</span><span>${ParseFloat(data?.delivery_charges)}</span></div>` : ''}
              ${data?.remaning_amount ? `<div class="row"><span>${t("Checkout.remainingAmount")}</span><span>${ParseFloat(data?.remaning_amount)}</span></div>` : ''}
              ${data?.total_tax ? `<div class="row"><span>${t("MyOrders.taxes")}</span><span>${ParseFloat(data?.total_tax)}</span></div>` : ''}
              <div class="row total"><span>${t("CartDetails.total")}</span><span>${ParseFloat(data?.total_price)}</span></div>
            </div>
          </body>
        </html>
        `;

        const iframe = iframeRef.current;
        if (!iframe) return;

        const doc = iframe.contentWindow?.document;
        if (doc) {
            doc.open();
            doc.write(htmlContent);
            doc.close();

            // Wait for content to render, then print
            setTimeout(() => {
                iframe.contentWindow?.focus();
                iframe.contentWindow?.print();
            }, 500); // adjust delay if needed
        }
    };

    return (
        <>
            <button
                className="bg-[#34558b] text-white py-2 px-4 rounded w-full flex items-center justify-center gap-2"
                onClick={handleReceiptDownload}
            >
                <svg xmlns="http://www.w3.org/2000/svg" fill="none"
                    viewBox="0 0 24 24" strokeWidth={1.5}
                    stroke="currentColor" className="w-5 h-5">
                    <path strokeLinecap="round" strokeLinejoin="round"
                        d="M3 16.5v2.25A2.25 2.25 0 005.25 21h13.5A2.25 2.25 0 0021 18.75V16.5M7.5 12l4.5 4.5m0 0l4.5-4.5m-4.5 4.5V3"
                    />
                </svg>
                {t("OrderSuccess.downloadReceipt")}
            </button>

            {/* Hidden iframe for printing */}
            <iframe ref={iframeRef} style={{ display: 'none' }} />
        </>
    );
};

export default DownloadReceipt;
